import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ConsultaRequest from '../../../../shared/http-requests/ConsultaRequest';
import LoadingPage from '../../components/LoadingPage';
import { ToastifyHelper } from '../../../../shared/helpers';
import { ToastContainer } from 'react-toastify';
import Axios from "axios";

const PageStatistics = () => {
    const [statistics, setStatistics] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();


    useEffect(() => {
        const cancelTokenSrc = Axios.CancelToken.source();
        (async () => {
            try {
                setLoading(true);

                const statistics = await ConsultaRequest.getStatistics(cancelTokenSrc.token);
                const { data } = await statistics;
                if (data) {
                    setStatistics(data);
                }
                setLoading(false);
            } catch (e) {
                if(!Axios.isCancel(e)){
                    ToastifyHelper.error('Houve um erro!!!');
                    setLoading(false);
                }
            }
        })();

        return () => cancelTokenSrc.cancel()
    }, []);

    const getTranslated = term => {
        if (typeof term === 'string') return t(term);

        return term.t.map(v => t(v)).join(' ') + term[0];
    };

    return (
        (loading && <LoadingPage />) || (
            <div className="statistics">
                <div className="statistics-box">
                    <header className="statistics-header">
                        <h1 className="">
                            {t('EstatisticaEstatisticasGerais')}
                        </h1>
                    </header>
                    <div className="statistics-content">
                        <ul className="statistics-list">
                            {(statistics?.length &&
                                statistics.map(
                                    ({ title, items = null }, key) => (
                                        <li
                                            key={key}
                                            className="statistics-list-item"
                                        >
                                            <header className="statistics-list-item-header">
                                                {t(title)}
                                            </header>
                                            <main className="statistics-list-item-content">
                                                <ul>
                                                    {items?.length &&
                                                        items.map(
                                                            ({
                                                                descricao,
                                                                texto_explicativo,
                                                                cod_atividade,
                                                                total_active_users,
                                                                arquivo_destino,
                                                                description_translation_term,
                                                                sub_desc_translation_term,
                                                            }) => (
                                                                <li
                                                                    key={
                                                                        cod_atividade
                                                                    }
                                                                >
                                                                    {(cod_atividade ==
                                                                        1106 && (
                                                                        <div className="statistics-list-item-info">
                                                                            <span>
                                                                                {description_translation_term
                                                                                    ? getTranslated(
                                                                                          description_translation_term,
                                                                                      )
                                                                                    : texto_explicativo}
                                                                                :
                                                                            </span>
                                                                            <span>
                                                                                <strong>
                                                                                    {
                                                                                        total_active_users
                                                                                    }
                                                                                </strong>
                                                                            </span>
                                                                        </div>
                                                                    )) || (
                                                                        <>
                                                                            <Link
                                                                                className="statistics-list-item-title"
                                                                                to={`/estatistica/${arquivo_destino}`}
                                                                            >
                                                                                {description_translation_term
                                                                                    ? getTranslated(
                                                                                          description_translation_term,
                                                                                      )
                                                                                    : descricao}
                                                                            </Link>
                                                                            <p className="statistics-list-item-description">
                                                                                {sub_desc_translation_term
                                                                                    ? t(
                                                                                          sub_desc_translation_term,
                                                                                      )
                                                                                    : texto_explicativo}
                                                                            </p>
                                                                        </>
                                                                    )}
                                                                </li>
                                                            ),
                                                        )}
                                                </ul>
                                            </main>
                                        </li>
                                    ),
                                )) || <div />}
                        </ul>
                    </div>
                </div>
                <ToastContainer autoClose={6000} position="top-right" />
            </div>
        )
    );
};

export default PageStatistics;
